import { useMemo } from 'react'

import { CodeBlock } from './CodeBlock'

interface JsonCodeBlockProps {
  /** A JSON-serializable value (pretty-printed at 2-space indent) or an
   * already-formatted JSON string. */
  value: unknown
  label?: string
  className?: string
  showCopyButton?: boolean
}

export function JsonCodeBlock({
  value,
  label = 'JSON',
  className = '',
  showCopyButton = true,
}: JsonCodeBlockProps) {
  const code = useMemo(
    () => (typeof value === 'string' ? value : JSON.stringify(value, null, 2)),
    [value]
  )

  return (
    <CodeBlock
      code={code}
      language="json"
      label={label}
      className={className}
      showCopyButton={showCopyButton}
    />
  )
}
